import { Form, Data, FormField, ModalId, useUIActions, FieldType, FieldValue, O } from "../../../../features/ui"
import { useState } from "react"
import { validateTaxId } from "../../../../features/data-types"

type Props = {
    data?: Data
    isMain?: boolean
    onSubmit: (taxId: number, isMain: boolean) => void
}

export const TaxIdForm = (props: Props) => {
    const { data, isMain, onSubmit } = props
    const createMode = !data
    const isAlreadyMain = data?.main === true

    const [taxId, setTaxId] = useState<O<number>>((data?.taxId as O<number>))
    const [main, setMain] = useState(isMain ?? false)

    const { closeModal } = useUIActions()

    const onChangeTaxId = (value?: FieldValue) => setTaxId(value as O<number>)

    const fields: FormField[] = [
        {
            name: 'taxId',
            type: FieldType.NUMBER,
            defaultValue: taxId,
            label: 'CUIT',
            validate: validateTaxId,
            onChange: onChangeTaxId
        },
        {
            name: 'isMain',
            type: FieldType.BOOLEAN,
            defaultValue: main,
            label: 'Principal',
            disabled: isAlreadyMain,
            onChange: (v?: FieldValue) => setMain(v as boolean)
        }
    ]

    const handleSubmit = () => {
        onSubmit(taxId!, main)
        closeModal(ModalId.COMPANY_TAX_IDS)
    }

    const handleCancel = () => closeModal(ModalId.COMPANY_TAX_IDS)

    return (
        <Form
            formId="tax-id-form"
            fields={fields}
            createMode={createMode}
            createLabel="Agregar"
            onSubmit={handleSubmit}
            onCancel={handleCancel}
        />
    )
}
